export function cancelSubscription(arr): void {
    arr.forEach((element) => {
        if (element) {
            element.unsubscribe();
        }
    });
}


// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/shared/cancelSubscription.ts